import React, { useState, useEffect, useRef } from "react";

import CreateClient from "./CreateClient";

import "./../Usuarios/usuarios.css";

import { PermissionsForSection } from "../auth";
import { Sections } from "../../data/navItem";
import PagedFetch, { Init } from "../../helperFunctions/PagedFetch";
import ExportCSV from "../ExportCSV";
import ClientesNuevosSmall from "./ClientesNuevosSmall";
import ClientesKPIVentas from "./ClientesKPIVentas";
import ClientesKPICalidadInformacion from "./ClientesKPICalidadInformacion";
//import ClientesKPISmall from "./ClientesKPISmall";

export default function ClientesDashboard() {
  const createClientesRef = useRef();
  const csvRef = useRef();

  const [modalData, setModalData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  /** FILTERS */
  /** PAGING */
  const [searchCriteria, setSearchCriteria] = useState({});
  const [pageButtons, setPageButtons] = useState([Init.Vars.PageButtons]);

  ///start changes CLASS
  const pagingInfoRef = useRef(new PagedFetch());
  const [responsePagingInfo, setResponsePagingInfo] = useState({
    ...Init.Vars.ResponsePagingInfo,
  });

  const fetchData = async (resetPageNumber = true) => {
    setIsLoading(true);
    //  let criteria = searchCriteria;
    if (resetPageNumber) {
      /// reset pag info
      pagingInfoRef.current.resetPageInfo();
    }

    //  criteria = pagingInfoRef.current.buildFetch(criteria);
    //  searchFetchData(criteria);
  };

  useEffect(() => {
    fetchData();

    const newPermissions = PermissionsForSection(Sections.Clientes);
    setPermissions(newPermissions);
  }, []);

  function reloadClientes() {
    fetchData(false);
  }

  /**
   * Search handler
   */

  return (
    <>
      <ExportCSV ref={csvRef} />

      <CreateClient
        ref={createClientesRef}
        item={modalData}
        reloadClientes={reloadClientes}
      />

      <div className="bd-example">
        <div className="container  overflow-hidden">
          <div className="row  gx-5">
            <div className="col">
              <ClientesNuevosSmall />
            </div>

            <div
              className="col card1 recent-sales overflow-auto"
              style={{
                backgroundColor: "transparent",
                borderRadius: "0px",
                marginBottom: "30px",
              }}
            >
              <ClientesKPIVentas />
              <ClientesKPICalidadInformacion />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
